import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../services/supabase';

export const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the session from the URL hash (Supabase puts tokens there after OAuth)
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Auth callback error:', error);
          navigate('/login');
          return;
        }

        if (session?.user) {
          // Fetch user profile to determine role
          const { data: profile, error: profileError } = await supabase
            .from('profiles')
            .select('role')
            .eq('id', session.user.id)
            .single();

          if (profileError || !profile) {
            console.log('Profile not found, attempting to create one for OAuth user');

            // Try to create a profile for this OAuth user
            try {
              const newProfile = {
                id: session.user.id,
                email: session.user.email || '',
                role: 'parent', // Default role for self-registered OAuth users
                display_name: session.user.user_metadata?.full_name ||
                             session.user.user_metadata?.name ||
                             session.user.email?.split('@')[0] ||
                             'User'
              };

              const { data: createdProfile, error: createError } = await supabase
                .from('profiles')
                .insert(newProfile)
                .select('role')
                .single();

              if (createError) {
                console.error('Failed to create profile:', createError);
                navigate('/login');
                return;
              }

              console.log('Profile created successfully for OAuth user');

              // Redirect based on the newly created profile role
              switch (createdProfile.role) {
                case 'staff':
                  navigate('/staff');
                  break;
                case 'parent':
                  navigate('/parent');
                  break;
                case 'teacher':
                  navigate('/teacher');
                  break;
                default:
                  navigate('/login');
              }
              return;
            } catch (createErr) {
              console.error('Error creating profile:', createErr);
              navigate('/login');
              return;
            }
          }

          // Redirect based on role
          switch (profile.role) {
            case 'staff':
              navigate('/staff');
              break;
            case 'parent':
              navigate('/parent');
              break;
            case 'teacher':
              navigate('/teacher');
              break;
            default:
              navigate('/login');
          }
        } else {
          navigate('/login');
        }
      } catch (err) {
        console.error('Callback handling error:', err);
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
};
